export default "__VITE_ASSET__B5AWuM0B__"